import { render, staticRenderFns } from "./ldapUserGroupRelationship.vue?vue&type=template&id=cd47615c"
import script from "./ldapUserGroupRelationship.vue?vue&type=script&lang=js"
export * from "./ldapUserGroupRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports